import { ErrorHandler } from '@invision/core';

/** Handle the error by sending it to the logging endpoint via ErrorHandler. */
export function handleError(error: any): void {
  ErrorHandler.getInstance().handleRuntimeError(error);
}

/** Reset application state so error (hopefully) doesn't occur again. */
export function handleReset(): void {
  window.location.reload();
}
